import React from 'react';
import { Grid, Card, CardContent, Typography, CircularProgress } from '@material-ui/core';
import { ResponsiveBar } from '@nivo/bar';
import { useSwaggerClient } from '../../../../hooks/useSwaggerClient';

const CommissionChart = ({ agentId, fromDate, toDate, dateType, status }) => {
    const [dashboardData, loading] = useSwaggerClient(
        'users/statistics',
        'getAgentActivityDashboard',
        {
            agentId,
            fromDate,
            toDate,
            dateType,
            status
        },
        [agentId, fromDate, toDate, dateType, status]
    );

    const activities = dashboardData?.activities || [];

    if (loading) {
        return (
            <Grid item xs={12} md={6}>
                <Card>
                    <CardContent style={{ textAlign: 'center', padding: '40px' }}>
                        <CircularProgress />
                    </CardContent>
                </Card>
            </Grid>
        );
    }

    if (activities.length === 0) {
        return null;
    }

    // Sort by commission and take top 8
    const topActivities = activities
        .sort((a, b) => b.commission - a.commission)
        .slice(0, 8)
        .map(activity => ({
            activity:
                activity.activityName.length > 25
                    ? activity.activityName.substring(0, 25) + '...'
                    : activity.activityName,
            Commission: parseFloat(activity.commission.toFixed(2))
        }));

    return (
        <Grid item xs={12} md={6}>
            <Card>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        Top Activities by Commission
                    </Typography>
                    <div style={{ height: '400px' }}>
                        <ResponsiveBar
                            data={topActivities}
                            keys={['Commission']}
                            indexBy="activity"
                            layout="horizontal"
                            margin={{ top: 20, right: 40, bottom: 50, left: 140 }}
                            padding={0.3}
                            valueScale={{ type: 'linear' }}
                            indexScale={{ type: 'band', round: true }}
                            colors="#2196f3"
                            borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                            axisTop={null}
                            axisRight={null}
                            axisBottom={{
                                tickSize: 5,
                                tickPadding: 5,
                                tickRotation: 0,
                                legend: 'Commission ($)',
                                legendPosition: 'middle',
                                legendOffset: 40,
                                format: value => `$${value}`
                            }}
                            axisLeft={{
                                tickSize: 5,
                                tickPadding: 5,
                                tickRotation: 0
                            }}
                            labelSkipWidth={12}
                            labelSkipHeight={12}
                            labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                            label={d => `$${d.value}`}
                            animate={true}
                            motionStiffness={90}
                            motionDamping={15}
                        />
                    </div>
                </CardContent>
            </Card>
        </Grid>
    );
};

export default CommissionChart;
